// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;Lift up your heads, O gates;<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;be lifted up, you everlasting doors;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and the King of glory shall come in.<br> </p> </div></div>";
// Exports
module.exports = code;